import { Table } from "antd";
import $ from "jquery";
import moment from 'moment';
import 'moment-timezone';
import React, { useState, useEffect } from 'react';
import WeatherIcon from 'react-icons-weather';
import SessionManager from "../../routes/SessionManager";

function WeatherReport(props) {

    var sessionMgr = new SessionManager();
    var user1 = sessionMgr.readCookie('user');

    const [loading, setLoading] = useState(false);
    const [weather_recs, setWeatherRecs] = useState([]);
    const [user, setUser] = useState(user1);
    let timezone = user.site_selected.site_iana_timezone;

    let report_columns = [
        {
            title: "Date",
            dataIndex: 'location_name',
            key: 'location_name',
            render: (keep_it, w) => moment.tz(parseInt(w.local_epoch) * 1000, timezone).format('MMM DD, YYYY')
        },
        {
            title: "Sky",
            dataIndex: 'keep_it',
            key: 'keep_it',
            render: (keep_it, w) => <div>{w.img} {w.weather}</div>,
        },
        {
            title: "Temperature",
            dataIndex: 'keep_it',
            key: 'keep_it',
            render: (keep_it, w) => w.temperature,
        },
        {
            title: "Precipitation",
            dataIndex: 'keep_it',
            key: 'keep_it',
            render: (keep_it, w) => w.precipitation,
        },
    ];

    useEffect(() => {

        setUser(sessionMgr.readCookie('user'))
        setWeatherRecs([]);
        setLoading(true);
        if (user.site_selected)
            fetchWeatherReport();
    }, [])

    const fetchWeatherReport = () => {
        var data = {
            days: 7,
            date: props.pickedDate ? props.pickedDate : moment().format("YYYY-MM-DD"),
            customer_id: user.customer_id,
            site_id: user.site_selected.site_id,
            user_login: user.user_login,
            user_token: user.user_token
        }

        $.ajax(
            {
                url: 'https://gygnti76i5.execute-api.us-east-1.amazonaws.com/api-env-prod/weather',
                type: 'POST',
                contentType: "application/json; charset=utf-8",
                dataType: "json",
                data: JSON.stringify(data)
            }
        ).then(
            (res) => {
                if (res.status && res.status.code === 200) {
                    console.log('res', res);
                    var timezone = user.site_selected.site_iana_timezone;
                    if (!timezone)
                        timezone = moment.tz.guess(); // User's timezone if not found

                    var weatherData = [];
                    for (var rec of res.data) {
                        var resp = JSON.parse(rec.full_response);
                        var weatherRec = {};
                        weatherRec.date = rec.date;
                        weatherRec.local_epoch = rec.local_epoch;
                        weatherRec.log_id = rec.log_id;

                        if (resp.currently) {
                            weatherRec.weather = resp.currently.summary;
                            weatherRec.img = <WeatherIcon className="fa-lg" name="darksky" iconId={resp.currently['icon']} flip="horizontal" rotate="90" />;
                            weatherRec.precipitation = resp.currently.precipIntensity;
                            weatherRec.temperature = Math.round(resp.currently.temperature, 2) + '°F';
                        } else if (resp.current_observation) {
                            weatherRec.weather = resp.current_observation.weather;
                            weatherRec.img = <img src={resp.current_observation.icon_url} alt="Weather" width="20"></img>;
                            weatherRec.precipitation = Math.round(resp.current_observation.precip_1hr_in, 4);
                            weatherRec.temperature = resp.current_observation.temp_f + '°F';
                        } else {
                            if (resp.weather && resp.weather.length > 0) {
                                let weather = resp.weather[0];
                                weatherRec.weather = weather.main;
                                weatherRec.img = <img src={"http://openweathermap.org/img/wn/" + weather.icon + ".png"} alt="Weather" width="30"></img>;;
                            }
                            weatherRec.precipitation = rec.precip_1hr_string;
                            weatherRec.temperature = rec.temperature;
                        }
                        weatherData.push(weatherRec);
                    }
                    weatherData = props.pickedDate ? (weatherData.length > 0 ? [weatherData[weatherData.length - 1]] : []) : weatherData;

                    setWeatherRecs(weatherData.reverse());
                    setLoading(false);

                }
            },
            (res) => {

            });
    }

    return (
        <React.Fragment>
            <div className="modal-header p-2 bg-primary text-white">
                <span className="modal-title">{props.title}</span>
                <div>
                    <button type='button' className='fa fa-expand' onClick={props.resizeModal}></button>
                    <button type='button' className='far fa-lg fa-times-circle pull-right' data-dismiss='modal' onClick={props.closeModal}></button>
                </div>
            </div>
            {!loading &&
                <div className="modal-footer bg-light" style={{ height: "2rem", padding: '0.5rem 1rem' }}>
                    <label className="font-weight-bold text-primary" style={{ position: "absolute", left: "1rem" }}>{user && user.site_selected && user.site_selected.site_name}</label>
                </div>
            }

            <div className="modal-body py-4">
                <Table
                    loading={loading}
                    rowKey="log_id"
                    dataSource={weather_recs}
                    columns={report_columns}
                    pagination={false} />
            </div>
        </React.Fragment>
    );
}

export default WeatherReport;